// src/api/billingApi.ts
//
// Single-endpoint surface: the CRM BFF billing overview read.
//
//   GET /api/billing/overview
//       Returns plan/credits snapshot. Credits + AI capability are
//       Central-direct via `centralContext.getCreditBalance` /
//       `hasCapability`. Plan fields come from Central's
//       `SUBSCRIPTION_ME_PATH` via the server-side `getCentralSubscription`
//       helper — see `docs/BILLING-OWNERSHIP.md`.
//
// All Settings Billing actions (manage / add credits / upgrade) go
// browser-direct to Central via `centralBillingApi` — no BFF hop. No
// subscription / credit-bundle / portal-link mutations live here.

import { baseApi } from './baseApi';
import type { BillingOverview } from '../types/api';

export const billingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /api/billing/overview
    getBillingOverview: builder.query<BillingOverview, void>({
      query: () => '/billing/overview',
      providesTags: ['Billing'],
    }),
  }),
});

export const { useGetBillingOverviewQuery } = billingApi;
